import React from 'react';

import { cn } from 'lib/helpers/utility';

const CounterSpan = ({ children, size, className }) => {
  const textSizeClasses = {
    small: 'text-[8px]',
    medium: 'text-[10px]',
    large: 'text-[12px]'
  };

  return (
    <span
      className={cn(
        'flex items-center justify-center gap-0.5 text-center font-semibold leading-[14px] text-white',
        textSizeClasses[size],
        className
      )}>
      {children}
    </span>
  );
};

export default CounterSpan;
